/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { DELETE_LOAN_HISTORY_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(DELETE_LOAN_HISTORY_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((id) =>
      AjaxRequest.open(
        'delete',
        `/admin/loanhistorycustom/loanhistories/${id}/delete`,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
